// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRequisitesDto } from './IRequisitesDto';
import {
    IRequisitesDtoFromJSON,
    IRequisitesDtoFromJSONTyped,
    IRequisitesDtoToJSON,
    IRequisitesDtoToJSONTyped,
} from './IRequisitesDto';
import type { IPaymentMethodOwnerDto } from './IPaymentMethodOwnerDto';
import {
    IPaymentMethodOwnerDtoFromJSON,
    IPaymentMethodOwnerDtoFromJSONTyped,
    IPaymentMethodOwnerDtoToJSON,
    IPaymentMethodOwnerDtoToJSONTyped,
} from './IPaymentMethodOwnerDto';
import type { IPaymentAddressResponseDto } from './IPaymentAddressResponseDto';
import {
    IPaymentAddressResponseDtoFromJSON,
    IPaymentAddressResponseDtoFromJSONTyped,
    IPaymentAddressResponseDtoToJSON,
    IPaymentAddressResponseDtoToJSONTyped,
} from './IPaymentAddressResponseDto';

/**
 * 
 * @export
 * @interface IPaymentMethodSetupResponseDto
 */
export interface IPaymentMethodSetupResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodSetupResponseDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodSetupResponseDto
     */
    payment_method_type?: IPaymentMethodSetupResponseDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentMethodSetupResponseDto
     */
    is_default?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodSetupResponseDto
     */
    payment_method_status?: IPaymentMethodSetupResponseDtoPaymentMethodStatusEnum;
    /**
     * 
     * @type {IPaymentMethodOwnerDto}
     * @memberof IPaymentMethodSetupResponseDto
     */
    payment_method_owner?: IPaymentMethodOwnerDto;
    /**
     * 
     * @type {IPaymentAddressResponseDto}
     * @memberof IPaymentMethodSetupResponseDto
     */
    payment_address?: IPaymentAddressResponseDto;
    /**
     * 
     * @type {IRequisitesDto}
     * @memberof IPaymentMethodSetupResponseDto
     */
    requisites?: IRequisitesDto;
    /**
     * 
     * @type {number}
     * @memberof IPaymentMethodSetupResponseDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodSetupResponseDto
     */
    account_description?: string;
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodSetupResponseDto
     */
    verification_status?: IPaymentMethodSetupResponseDtoVerificationStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentMethodSetupResponseDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentMethodSetupResponseDtoPaymentMethodStatusEnum {
    VERIFIED = 'VERIFIED',
    PENDING_VERIFICATION = 'PENDING_VERIFICATION',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    NEW = 'NEW'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentMethodSetupResponseDtoVerificationStatusEnum {
    PENDING = 'PENDING',
    PENDING_MANUAL = 'PENDING_MANUAL',
    VERIFIED = 'VERIFIED',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IPaymentMethodSetupResponseDto interface.
 */
export function instanceOfIPaymentMethodSetupResponseDto(value: object): value is IPaymentMethodSetupResponseDto {
    return true;
}

export function IPaymentMethodSetupResponseDtoFromJSON(json: any): IPaymentMethodSetupResponseDto {
    return IPaymentMethodSetupResponseDtoFromJSONTyped(json, false);
}

export function IPaymentMethodSetupResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentMethodSetupResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'payment_method_status': json['payment_method_status'] == null ? undefined : json['payment_method_status'],
        'payment_method_owner': json['payment_method_owner'] == null ? undefined : IPaymentMethodOwnerDtoFromJSON(json['payment_method_owner']),
        'payment_address': json['payment_address'] == null ? undefined : IPaymentAddressResponseDtoFromJSON(json['payment_address']),
        'requisites': json['requisites'] == null ? undefined : IRequisitesDtoFromJSON(json['requisites']),
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'verification_status': json['verification_status'] == null ? undefined : json['verification_status'],
    };
}

export function IPaymentMethodSetupResponseDtoToJSON(json: any): IPaymentMethodSetupResponseDto {
    return IPaymentMethodSetupResponseDtoToJSONTyped(json, false);
}

export function IPaymentMethodSetupResponseDtoToJSONTyped(value?: IPaymentMethodSetupResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payment_method_type': value['payment_method_type'],
        'is_default': value['is_default'],
        'payment_method_status': value['payment_method_status'],
        'payment_method_owner': IPaymentMethodOwnerDtoToJSON(value['payment_method_owner']),
        'payment_address': IPaymentAddressResponseDtoToJSON(value['payment_address']),
        'requisites': IRequisitesDtoToJSON(value['requisites']),
        'account_id': value['account_id'],
        'account_description': value['account_description'],
        'verification_status': value['verification_status'],
    };
}

